import React, { useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, theme } from "antd";
import MenuButton from "../dropdown/Menu";
import { useLocation, useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const { Header, Sider, Content } = Layout;

const Layout1 = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const params = useParams();
  console.log("params", params);
  // token for color
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // function to get Tabs Props
  function getItem(label, key, icon, children, theme) {
    return {
      key,
      icon,
      children,
      label,
      theme,
    };
  }

  // handler to show active part
  const activeTabHandler = (acitveRoute) => {
    switch (acitveRoute) {
      case "/":
        return "1";
      case "/add-duomo-blog":
        return "2";
      case "/gng-blogs":
        return "3";
      case "/add-gng-blog":
        return "4";
      default:
        return "1";
    }
  };

  // handler to show active sub menu options
  const activeSubOptionHandler = (acitveRoute) => {
    switch (acitveRoute) {
      case "/":
        return "sub1";
      case "/add-duomo-blog":
        return "sub1";
      case "/gng-blogs":
        return "sub2";
      case "/add-gng-blog":
        return "sub2";
      default:
        return "";
    }
  };

  // sidenav items
  const items = [
    getItem(<Link>Duomo</Link>, "sub1", <ProfileOutlined />, [
      getItem(<Link to="/">Blogs</Link>, "1"),
      getItem(<Link to="/add-duomo-blog">Add Blogs</Link>, "2"),
    ]),
    getItem(<Link>G&G</Link>, "sub2", <ProfileOutlined />, [
      getItem(<Link to="/gng-blogs"> Blogs</Link>, "3"),
      getItem(<Link to="/add-gng-blog">Add Blogs</Link>, "4"),
    ]),
  ];
  return (
    <Layout style={{ height: "100vh" }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <div>
          {!collapsed ? (
            <Link to="/">
              <div className="sidebar_logo">
                <h6>DUOMO-G&G</h6>
              </div>
            </Link>
          ) : (
            <Link to="/">
              {" "}
              <div className="sidebar_logo">
                <h6>D-G</h6>
              </div>
            </Link>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[activeTabHandler(location?.pathname)]}
          defaultOpenKeys={[activeSubOptionHandler(location?.pathname)]}
          items={items}
          selectedKeys={[activeTabHandler(location?.pathname)]}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "20px",
              width: 64,
              height: 64,
            }}
          />
          <MenuButton />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            overflowY: "scroll",
            background: colorBgContainer,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Layout1;
